module.exports = __webpack_public_path__ + "static/media/tjpho.6dda3e38.png";